import styled, { css } from 'styled-components';
import { getBreakpointsForHeaderVersion } from 'src/components/ZillowNavbar/utils/getBreakpointsForHeaderVersion';
import { ZillowSVGImage } from '../../common/ZillowSVGImage/ZillowSVGImage';
import { InternalLogoProps } from './InternalLogoProps';

export const DesktopZillowSearchPageLogo = styled(ZillowSVGImage)<InternalLogoProps>`
    width: 160px;
    height: 35px;
    display: block;
    ${({ isMobileNavOpen, version }) =>
        !isMobileNavOpen &&
        css`
            @media (max-width: ${getBreakpointsForHeaderVersion(version).MOBILE}px) {
                display: none;
            }
        `}
`;
